// toErrorMessage extracts a human-readable message from a thrown value, falling
// back to `fallback` for non-Error throwables or empty messages. Used by the
// receiving action screens to surface backend {message} bodies (e.g. the 409
// "companion is not connected") that the fetch wrapper rethrows, and by the route
// error boundaries, which receive whatever was thrown — null included.
export function toErrorMessage(
  err: unknown,
  fallback = 'Something went wrong — please try again.'
): string {
  return err instanceof Error && err.message ? err.message : fallback;
}
